










import { Component, Vue, Watch } from "vue-property-decorator";
import PrecheckCar from "./PrecheckCar.vue";
import PrecheckDate from "./PrecheckDate.vue";
import PrecheckDrivers from "./PrecheckDrivers.vue";
import PrecheckCalcs from "./PrecheckCalcs.vue";
import { Widget } from "@/services/index.defs";

@Component({
    components: {
        PrecheckCar,
        PrecheckDate,
        PrecheckDrivers,
        PrecheckCalcs,
    },
})
export default class PrecheckHost extends Vue {
    get step() {
        return this.$store.direct.state.insurance.step;
    }

    set step(newStep) {
        this.$store.direct.commit.insurance.setStep(newStep)
    }

    get stepComponent() {
        const steps = [
            PrecheckCar,
            PrecheckDate,
            PrecheckDrivers,
            PrecheckCalcs,
        ];
        const stepIdx = this.step - 1;
        if (Number.isInteger(stepIdx) && stepIdx >= 0 && stepIdx < steps.length)
            return steps[stepIdx];

        return null;
    }

    get widget(): Widget {
        return this.$store.direct.state.widget;
    }

    created() {
        const pstep = this.$route.params["step"];
        if (!!pstep) this.step = +pstep;
        else {
            if (this.widget.gosSignOn) this.step = 1;
            else this.step = 2;
        }
    }

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    toNextStep(stepNum?: number) {
        if (this.isFastCalcDisabled && this.step === 3) {
            this.$router.push({ name: 'stepper' });
            return;
        }

        if (Number.isFinite(stepNum)) {
            this.step = stepNum;
            return;
        }

        this.step++;
    }

    toBeforeStep() {
        if (this.step === 1) {
            this.back();
            return;
        }
        this.step--;
    }

    back() {
        this.$store.state.showRecentCalc = true;
        this.$router.push({ name: "welcome" });
    }

    @Watch("step") scrollToTop() {
        this.$root.scrollUp();
    }
}
